import { z } from "zod";

const userSchema = z.object({
  browser: z
    .object({
      type: z.string().nullable(),
      family: z.string().nullable(),
      version: z.string().nullable(),
      major_version: z.string().nullable(),
    })
    .nullable(),
  os: z
    .object({
      name: z.string().nullable(),
      version: z.string().nullable(),
    })
    .nullable(),
  device: z
    .object({
      model: z.string().nullable(),
      vendor: z.string().nullable(),
    })
    .nullable(),
  cpu: z
    .object({
      architecture: z.string().nullable(),
    })
    .nullable(),
  logged_in: z.boolean().nullable(),
  hybrid_id: z.string().nullable(),
  kiosq_id: z.string().nullable(),
  user_grant_status: z.string().nullable(),
  blue_conic_id: z.string().nullable(),
  ga_client_id: z.string().nullable(),
  gclid: z.string().nullable(),
  sha256_email_hash: z.string().nullable(),
  screen_width: z.number().nullable(),
  ua: z.string().nullable(),
  referrer: z.string().nullable(),
});

const sessionSchema = z.object({
  url: z.string().nullable(),
  id: z.number().int().nonnegative().nullable(),
  ga_id: z.number().int().nonnegative().nullable(),
});

export const adDensityMetricEventSchema = z
  .object({
    adDensity: z.number(),
    user: userSchema.optional(),
    session: sessionSchema.optional(),
  })
  .strict();

export default adDensityMetricEventSchema;

export type AdDensityMetricPayload = z.infer<typeof adDensityMetricEventSchema>;
export type User = z.infer<typeof userSchema>;
export type Session = z.infer<typeof sessionSchema>;
